import axios from "axios";

export default class Order {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_ORDER;
    this.name = "/orders";
    this.url = this.base_url + this.name;
  }

  grid = async (skip = 0, take = 100, category, filters = {}) => {
    const query = new URLSearchParams({ skip, take, category });

    if (filters.stateId) query.set("state_id", filters.stateId);
    if (filters.tagId) query.set("tag_ids", filters.tagId);
    if (filters.search?.trim()) query.set("search", filters.search.trim());
    if (filters.productIds?.length)
      query.set("product_ids", filters.productIds.join(","));

    return await axios.get(`${this.url}?${query.toString()}`);
  };

  gridByActive = async (
    skip = 0,
    take = 100,
    active,
    category,
    filters = {}
  ) => {
    const query = new URLSearchParams({ skip, take, active, category });

    if (filters.stateId) query.set("state_id", filters.stateId);
    if (filters.tagId) query.set("tag_ids", filters.tagId);
    if (filters.search?.trim()) query.set("search", filters.search.trim());
    if (filters.productIds?.length)
      query.set("product_ids", filters.productIds.join(","));

    return await axios.get(`${this.url}?${query.toString()}`);
  };

  today = async () => {
    return await axios.get(`${this.base_url}/commons/today`);
  };

  getById = async (id) => {
    return await axios.get(`${this.url}/${id}`);
  };

  updateComments = async (id, comments, updatedAt) => {
    return await axios.patch(`${this.url}/${id}/comments`, {
      comments,
      updated_at: updatedAt,
    });
  };

  getStates = async ({ active = 1 } = {}) => {
    return await axios.get(
      `${this.base_url}/states?skip=0&take=100&active=${active}&type=ORDER`
    );
  };

  getTags = async ({ active } = {}) => {
    const query = typeof active === "undefined" ? "" : `?active=${active}`;
    return await axios.get(`${this.base_url}/order-tags${query}`);
  };

  transitionState = async (id, stateId, idempotencyKey) => {
    return await axios.post(
      `${this.url}/${id}/state`,
      { state_id: stateId },
      { headers: { "Idempotency-Key": idempotencyKey } }
    );
  };

  syncTags = async (id, tagIds) => {
    return await axios.put(`${this.url}/${id}/tags`, { tag_ids: tagIds });
  };

  createState = async (payload) => {
    return await axios.post(`${this.base_url}/states`, payload);
  };

  updateState = async (id, payload) => {
    return await axios.put(`${this.base_url}/states/${id}`, payload);
  };

  changeStateActive = async (id, active) => {
    return await axios.patch(`${this.base_url}/states/${id}/active`, {
      active,
    });
  };

  createTag = async (payload) => {
    return await axios.post(`${this.base_url}/order-tags`, payload);
  };

  updateTag = async (id, payload) => {
    return await axios.put(`${this.base_url}/order-tags/${id}`, payload);
  };

  changeTagActive = async (id, active) => {
    return await axios.patch(`${this.base_url}/order-tags/${id}/active`, {
      active,
    });
  };

  exportOrder = async (id) => {
    return await axios.get(`${this.url}/export_order/${id}`, {
      responseType: "blob",
    });
  };

  numeroDeComprobante = async (categoryId) => {
    return await axios.get(`${this.url}/next_number/category/${categoryId}`);
  };

  create = async (payload) => {
    await axios.post(this.url, payload);
  };

  /*

  update = async (id, payload) => {
    await axios.put(`${this.url}/${id}`, payload);
  };

  changeActive = async (id) => {
    await axios.patch(`${this.url}/${id}`);
  };*/
}
